import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Toast from "../../Components/Toast";
import Loading from "../../Layouts/Loading";
import {useNavigate, useParams} from "react-router-dom";
import Header from "../../Layouts/Header";
import Navbar from "../../Layouts/Navbar";
import {AiOutlineAppstoreAdd} from "react-icons/ai";
import {HiOutlineQrcode} from "react-icons/hi";

import {BsCalendar4Week} from "react-icons/bs";
import Barcode from 'react-barcode';
import {TbBuildingStore} from "react-icons/tb";


function OrderDetails() {
    const navigate = useNavigate();
    const {id} = useParams();
    const [order, setOrder] = React.useState([]);
    const [isLoaded, setIsLoaded] = React.useState(true);

    React.useEffect(() => {
        const params = {
            'processFor': 'Sales',
            'returned': 1
        }

        API.getOrder(params, id)
            .then((response) => {
                setOrder(response.data);

                setIsLoaded(true);

            })
            .catch((error) => {

                if (error.response) {
                    toast.error(error.response.data.message);
                    setTimeout(() => {
                        window.history.back()
                    }, 400)
                } else {
                    toast.error(error.message);
                    setTimeout(() => {
                        window.history.back()
                    }, 400)
                }
            });


    }, [id]);


    const onStatusButtonClick = (statusId) => {
        setIsLoaded(false);
        const request = {
            'order_id': id,
            'status_id': statusId,
            'processFor': 'Sales',

            'calc_battery_count': 1
        }
        API.updateStatus(request)
            .then((response) => {
                toast.success(response.message);
                setTimeout(() => {
                    navigate('/returned-orders/');
                }, 2000);
            })
            .catch((error) => {
                toast.error(error.response.data.message)
                setIsLoaded(true);
            });
    }


    return (
        <React.Fragment>
            <Header/>

            <Navbar page="return-orders" public="1"/>
            <Toast/>
            {
                !isLoaded && <Loading/>
            }
            <main id="main" className="main rtl">

                <div className="pagetitle mb-5 border-bottom pb-4">
                    <h1>
                        <AiOutlineAppstoreAdd className='ms-2'/>
                        مدیریت سفارش
                    </h1>

                </div>

                <section className="section">
                    <div className="row">
                        <div className="col-lg-12">

                            <div className="card">
                                <div className="card-body">
                                    <div className="row mx-2 mb-3 border-bottom pb-2 pt-5">
                                        <div className="col-1">
                                            <TbBuildingStore/>
                                        </div>
                                        <div className="col-5 text-small-2">
                                            نماینده:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order?.vendor?.title}
                                            &nbsp;
                                            (
                                            {order?.vendor?.city}
                                            )
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 border-bottom pb-2 ">
                                        <div className="col-1">
                                            <HiOutlineQrcode/>
                                        </div>
                                        <div className="col-5 text-small-2">
                                            کد رهگیری:
                                        </div>
                                        <div className="col-6 text-start fw-bold text-small-2">
                                            {order.tracking_code}
                                        </div>
                                    </div>

                                    <div className="row mx-2 mb-3 pb-2 ">
                                        <div className="col-1">
                                            <BsCalendar4Week/>
                                        </div>
                                        <div className="col-4 text-small-2">
                                            تاریخ ثبت
                                        </div>
                                        <div className="col-7 text-start fw-bold text-small-2">
                                            {order.date}
                                        </div>
                                    </div>
                                    <div className="row mx-2 mb-3 pb-2 list-battery">
                                        <div className="col-12 text-small-2 border-bottom pb-2 text-primary">
                                            باتری ها
                                        </div>
                                        <div className="col-12">
                                            <div className="row">
                                                {
                                                    order?.details?.batteries?.map(bt => {
                                                        return (
                                                            <div className="col-3  px-3 mt-3">
                                                                <div className='bg-white rounded p-1'

                                                                >
                                                                    <Barcode value={bt} height={20} width={1}
                                                                             fontSize={12}/>
                                                                </div>
                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>

                        </div>


                    </div>
                </section>

            </main>

        </React.Fragment>
    );
}

export default OrderDetails;